<template>
    <div class="factory">
      <factory-container></factory-container>
    </div>
</template>
<script>
import FactoryContainer from '@/components/factory/Container.vue'
export default {
  name: 'factory',
  components: {
    FactoryContainer
  }
}
</script>
<style lang="stylus">
  .factory
    height 100%
</style>
